<template>
  <div>
    <read
      class="read"
      v-for="(persona, index) in reads"
      :key="index"
      v-bind:id="persona.id"
      v-bind:idEstado="persona.id + 'id'"
      v-bind:nombre="persona.username"
      v-bind:nombreimage="persona.image"
      v-bind:last_story="persona.last.tipo"
      v-bind:background="persona.last.background"
      v-bind:image="persona.last.image"
      v-bind:class="`${persona.last.background}`"
      v-bind:nStatus="$store.getters.getEstados(persona.id)"
      v-bind:hora="$store.getters.getHora(persona.id)"
      v-bind:nPersona="persona"
      v-bind:nEstados="$store.getters.getNEstados(persona.id)"
      v-bind:nNuevos="$store.getters.getNNuevos(persona.id)"
      v-bind:reads="reads"
      v-bind:persona="persona"
      :stories="stories"
      :authuser="authuser"
      :activ="activ"
      v-if="reads.length"
    />
  </div>
</template>

<script>
import read from "./read.vue";
export default {
  components: {
    read,
  },
  data() {
    return {
      id: null,
      unseen: null,
    };
  },
  props: {
    stories: {},
    authuser: {},
    activ: {},
    title: { type: String, required: true },
    reads: { type: Array, required: true },
  },
  methods: {
    showStory(nPersona, id, estados, estadoid) {
      const i = this.stories.findIndex((item) => item.id === id);

      // const c = this.stories.findIndex(item => item.id === estadoid)

      const c = this.stories.find((item) => item.id === estadoid);
      const d = c.duration ? c.duration : 7000;

      return this.$router.push("/story/" + i);
    },
  },
  computed: {
    getId() {
      return this.$store.getters.getIndex(this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}

.profile-image1 {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
.reads {
  display: flex;
  justify-content: space-between;
  height: 10rem;
  gap: 1rem;
  position: relative;
}

.reads .read {
  padding: 10px;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 0.75rem;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.reads .read-mobile {
  padding: 1rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 0.75rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  display: none;
}
.reads .read .profile-image {
  border: 4px solid rgba(0, 110, 255, 0.582);
  width: 2rem;
  height: 2rem;
  align-self: start;
}
.reads .read .profile-image1 {
  border: 2px solid gainsboro;
  width: 2rem;
  height: 2rem;
  align-self: start;
}
.reads .f::before {
  content: "";
  display: block;
  width: 100%;
  height: 5rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  position: absolute;
  bottom: 0;
  z-index: 1;
}
.read .name {
  z-index: 2;
  margin-bottom: 1px;
}

@media (max-width: 600px) {
  .read-mobile {
    display: block;
  }
}

.gradient-1 {
  border-radius: 0.75rem;
  background: linear-gradient(pink, orange);
}

.gradient-2 {
  border-radius: 0.75rem;
  background: linear-gradient(19deg, #21d4fd 0%, #b721ff 100%);
}

.gradient-3 {
  border-radius: 0.75rem;
  background: linear-gradient(45deg, #fa8bff 0%, #2bd2ff 52%, #2bff88 90%);
}

.gradient-4 {
  border-radius: 0.75rem;
  background-image: linear-gradient(
    90deg,
    #ff9a8b 0%,
    #ff6a88 55%,
    #ff99ac 100%
  );
}

.gradient-5 {
  border-radius: 0.75rem;
  background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);
}

.gradient-6 {
  border-radius: 0.75rem;
  background-image: linear-gradient(19deg, #3eecac 0%, #ee74e1 100%);
}

.gradient-7 {
  border-radius: 0.75rem;
  background-image: linear-gradient(
    225deg,
    #ff3cac 0%,
    #784ba0 50%,
    #2b86c5 100%
  );
}

.gradient-8 {
  border-radius: 0.75rem;
  background-image: linear-gradient(0deg, #08aeea 0%, #2af598 100%);
}

.gradient-9 {
  border-radius: 0.75rem;
  border: 1px solid gainsboro;
}

.text {
  margin: auto;
  width: 70px;
  height: 70px;
  color: lightgray;
  position: relative;
  margin: 0;
  text-align: center;
  overflow-wrap: break-word;
  font-size: 9px;
  overflow: hidden;
  font-weight: bold;

  max-height: 65px;
}

.bg-video-wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  background: url(https://designsupply-web.com/samplecontent/vender/codepen/20181014.png)
    no-repeat center center/cover;
}
video {
  min-width: 100%;
  min-height: 100vh;
  z-index: 1;
}
</style>
